export const ArrowLeftModal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      stroke="#0A0D14"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20 4.5v1.4c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622c-1.283.654-2.964.654-6.324.654H4m0 0 5-5m-5 5 5 5"
    />
  </svg>
);
